import { render } from "./NoData.vue?vue&type=template&id=79150c94&scoped=true"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import "./NoData.vue?vue&type=style&index=0&id=79150c94&scoped=true&lang=css"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79150c94"]])

export default __exports__